import { render, staticRenderFns } from "./Heroicon.vue?vue&type=template&id=31ce7c0b&"
import script from "./Heroicon.vue?vue&type=script&lang=js&"
export * from "./Heroicon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports